import api from './api.js';

const getAllWeeksEndpoint = "api/weeks/get-all";
const createWeekEndpoint = "api/weeks/create";
const updateWeekEndpoint = "api/weeks/update";
const deleteWeekEndpoint = "api/weeks/delete";
const getClientWeeklyMenusEndpoint = "api/weeks/get-client-weekly-menus";
const getClientWeeklyEndpoint = "api/weeks/get-client-weekly/";
const shareClientWeeklyEndpoint = "api/weeks/share-client-weekly/";
const getShareClientWeeklyEndpoint = "api/v1/weekly-menus/share/";

export default {

    setAxios(){
        api.setAxios();
    },

    getAllWeeks(nutritionist_id) {
        return api.get(getAllWeeksEndpoint+'/'+nutritionist_id);
    },

    createWeek(payload) {
        return api.post(createWeekEndpoint,payload);
    },

    updateWeek(payload) {
        return api.post(updateWeekEndpoint,payload);
    },

    deleteWeek(id) {
        return api.post(deleteWeekEndpoint+'/'+id);
    },
    getClientWeeklyMenus(page,client=null){
        let params = "?page="+page;

        if(!!client){
            params += ("&client="+client);
        }
        
        return api.get(getClientWeeklyMenusEndpoint+params);
    },
    getClientWeekly(week_id,client_id){
        return api.get(getClientWeeklyEndpoint+week_id+'/'+client_id);
    },
    shareClientWeekly(week_id,client_id){
        return api.post(shareClientWeeklyEndpoint+week_id+'/'+client_id,{});
    },
    getShareClientWeekly(uid){
        return api.get(getShareClientWeeklyEndpoint+uid);
    }
    
}
